import { handleActions } from 'redux-actions';
import { NotificationManager } from "react-notifications";
import { initialize as initializeForm } from 'redux-form';
import { api } from "api";

let url = 'cost-of-sales';
let form = 'CostoVentasForm';
// ------------------------------------
// Constants
// ------------------------------------
export const constants = {
    LOADER: 'COSTO_DE_VENTAS_LOADER',
    DATA: 'COSTO_DE_VENTAS_COMPRAS',
    ITEM_DATA: 'COSTO_DE_VENTAS_ITEM',
    TAB_EN_CURSO: 'COSTO_DE_VENTAS_TAB_EN_CURSO',
    SET_STEP: 'COSTO_DE_VENTAS_SET_STEP',
    CURRENCY:'CURRENCY',
    COMPARATIVO_DATA: 'COSTO_DE_VENTAS_COMPARATIVO_DATA'
}

// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});
const setData = data => ({
    type: constants.DATA,
    data,
});

const setItem = item => ({
    type: constants.ITEM_DATA,
    item,
});

const setComparativoData = comparativoData => ({
    type: constants.COMPARATIVO_DATA,
    comparativoData,
});


// -----------------------------------
// Actions
// -----------------------------------
const getCostOfSales = () => (dispatch) => {
    dispatch(setLoader(true));

    api.get(`${url}/get_cost_of_sales`)
        .then((response) => {
            dispatch(setData(response));
            dispatch(initializeForm(form, response));
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en lectura de datos', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getDollar = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`administrative/get_dollar_exchange`).then((response) => {
        dispatch(setItem(response.dollar_exchange));
        dispatch(initializeForm(form, response.results));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${url}/${id}`, data).then((response) => {
        NotificationManager.success(response.detail, 'Éxito', 3000);
        dispatch(getCostOfSales())
        dispatch(setCurrency('USD'));
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const convertirMoneda = ({ latex_data, solido_data, skim_data, item, change, currency }) => (dispatch) => {
    const tasa = parseFloat(item || 1);
    const convertirADolares = currency === 'USD';
    const factor = convertirADolares ? (1 / tasa) : tasa;

    const tablas = [
        { data: latex_data, prefix: 'latex_data' },
        { data: solido_data, prefix: 'solido_data' },
        { data: skim_data, prefix: 'skim_data' },
    ];

    tablas.forEach(({ data, prefix }) => {
        if (!data) return;

        Object.keys(data).forEach((month) => {
            const monthData = data[month];
            if (!monthData) return;

            Object.keys(monthData).forEach((seccion) => {
                const fila = monthData[seccion];
                if (!fila) return;

                const kgs = parseFloat(fila.kgs_secos || 0);
                const costo = parseFloat(fila.costo_kg_seco || 0);

                const nuevoCosto = (costo * factor).toFixed(5);
                const nuevoTotal = (kgs * parseFloat(nuevoCosto)).toFixed(2);

                change(`${prefix}.${month}.${seccion}.costo_kg_seco`, nuevoCosto);
                change(`${prefix}.${month}.${seccion}.valor_total`, nuevoTotal);
            });
        });
    });
};

const setCurrency = (currency) => (dispatch) => {
    dispatch({ type: constants.CURRENCY, currency })
}

const getComparativoData = () => (dispatch) => {
    api.get('comparativo_mp_ventas/get_tables_comparativo_mp_ventas')
        .then((response) => {
            dispatch(setComparativoData(response.ComparativoCostoVentas || {}));
        })
        .catch((error) => {
            console.error('Error fetching comparativo data:', error);
            dispatch(setComparativoData({}));
        });
};

const setTab = (tab) => (dispatch) => {
    dispatch(setLoader(true));
    dispatch({ type: constants.TAB_EN_CURSO, tab });
    dispatch(setLoader(false));
};

export const actions = {
    editar,
    getCostOfSales,
    getDollar,
    setTab,
    convertirMoneda,
    setCurrency,
    getComparativoData
};

// -----------------------------------
// Reducers
// -----------------------------------
const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [constants.DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },

    [constants.ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [constants.TAB_EN_CURSO]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },
    [constants.CURRENCY]: (state, { currency }) => {
        return {
            ...state,
            currency,
        };
    },
    [constants.COMPARATIVO_DATA]: (state, { comparativoData }) => {
        return {
            ...state,
            comparativoData,
        };
    },

};
export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    tab: 'COSTO_DE_VENTAS',
    currency: 'USD',
    comparativoData: {},
};
export default handleActions(reducers, initialState)
